export default __webpack_public_path__ + "content/media/6.af07d2a3.jpg";